import { catchError, map } from 'rxjs/operators';
import { Pipe, PipeTransform } from '@angular/core';
import { EntityStoreService } from '../services/entity-store.service';
import { Observable, of } from 'rxjs';

@Pipe({ name: 'entityLabel' })

export class EntityLabelPipe implements PipeTransform {
	constructor(
		protected entityStore: EntityStoreService,
	) {

	}

	transform(entity: any, noFallback = false): Observable<string> {
		const m = this.entityStore.getEntityMapping(entity.type);
		const esEntityPromise = this.entityStore.getEntityAsync(entity.type, entity.value);
		return esEntityPromise.pipe(
			map((en) => en[m.label] || en[m.backupLabel] || en[m.value]),
			catchError((e) => {
				if (e && e.code === '404') {
					return of(noFallback ? '' : `${entity.value} (deleted)`);
				}
			})
		);
	}
}
